// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"c13232ba","94":"152f525c","150":"85c91d6f","154":"5be454ea","493":"2052a60b","594":"6476cfa0"}[chunkId] + ".css";
};